/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SenderOption
 */
export interface SenderOption {
    /**
     * 
     */
    fromNumber: string;
    /**
     * 
     */
    name: string | null;
    /**
     * 
     */
    count: number;
}

/**
 * Check if a given object implements the SenderOption interface.
 */
export function instanceOfSenderOption(value: object): value is SenderOption {
    if ((!('fromNumber' in (value as Record<string, any>)) && !('from_number' in (value as Record<string, any>))) || ((value as Record<string, any>)['fromNumber'] === undefined && (value as Record<string, any>)['from_number'] === undefined)) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function SenderOptionFromJSON(json: any): SenderOption {
    return SenderOptionFromJSONTyped(json, false);
}

export function SenderOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SenderOption {
    if (json == null) {
        return json;
    }
    return {
        
        'fromNumber': json['from_number'],
        'name': json['name'],
        'count': json['count'],
    };
}

export function SenderOptionToJSON(json: any): SenderOption {
    return SenderOptionToJSONTyped(json, false);
}

export function SenderOptionToJSONTyped(value?: SenderOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from_number': value['fromNumber'],
        'name': value['name'],
        'count': value['count'],
    };
}

